import Person from './Person'

export default function PeopleView(props) {
    return (
        <div className="PeopleView" onClick={props.onClick}>
            { props.people?.map( person => <Person person={person} key={person.id} editing={props.editing} onRemove={props.onRemovePerson}>{ person.username }</Person>) }
        </div>
    )
}
